export enum FixedChartSourceFiltersEnum {
    NAME = 'NAME',
    SEARCH_TYPE = 'SEARCH_TYPE',
    LIST_TYPE = 'LIST_TYPE',
    STATUS = 'STATUS',
    CREATED_BY = 'CREATED_BY',
    DATE_CREATED = 'DATE_CREATED',
    MODIFIED_BY = 'MODIFIED_BY',
    DATE_MODIFIED = 'DATE_MODIFIED',
};
